import bookingService from './../../../services/booking';
import mixin from '../../../mixins/mixin';

export default {
  data() {
    return {
      loading: true,
      path: '',
    };
  },
  components: {
    VLoading: require('components/loading/loading.vue'),
  },
  mixins: [mixin],
  mounted() {
    this.downloadIcsCalendar();
  },
  methods: {
    downloadIcsCalendar() {
      bookingService.exportIcs(this);
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/rentals/exportIcs/exportIcs.js